/** @type {
 	(setId: string, plasmidId: string, length: number) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }
) => import("../interfaces/ISGApiClient").Plasmid | null} */
const getPlasmidSequenceLineHeights =
	(setId, plasmidId, length) =>
	({ sgApiClient }) =>
		sgApiClient
			.getSequenceLineHeights(setId, plasmidId, length)
			.then((data) => {
				if (typeof data === "undefined") {
					return null;
				}

				const {
					filename,
					relative_path,
					line_count,
					est_line_height,
					last_line_heights,
					length: len,
				} = data;

				return {
					filename,
					relativePath: relative_path,
					lineCount: line_count,
					estLineHeight: est_line_height,
					lastLineHeights: last_line_heights,
					length: len,
				};
			});

export default getPlasmidSequenceLineHeights;
